import { Popper, ClickAwayListener, Fade, Paper, Box, Button, createTheme, Typography, ThemeProvider } from "@mui/material";
import React, { useState } from "react";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Textarea } from "@mui/joy";
import CustomCurrencyTextField from "../../components/CustomCurrencyTextField";
import CustomTextField from "../../components/CustomTextField";
import DateSelector from "../../components/DateSelector";
import HistoryTable from "../../components/HistoryTable";
import MultiSelectPrimary from "../../components/MultiSelectPrimary";
import SelectBox from "../../components/SelectBox";
import { CssVarsProvider as JoyCssVarsProvider } from '@mui/joy/styles';
import GroundDetailsTable from "../../components/GroundDetailsTable";
import './styles.css'
import { useDispatch, useSelector } from "react-redux";
import { useTranslation } from "react-i18next";
import { isEmpty } from "../../common/StaticExports";
import { setIsUpdatedFacility, setSelectedFacility } from "../../redux/reducers/dataCaptures";
import FacilityStatusSelect from "../../components/FacilityStatusSelect";
import CapablitiesAutocomplete from "../../components/CapablitiesAutocomplete";

const theme = createTheme({
    components: {
        MuiPaper: {
            styleOverrides: {
                root: {
                    marginLeft: 'auto',
                    marginRight: 'auto',
                    marginTop: '7%'
                },
            }
        },
        MuiTypography: {
            styleOverrides: {
                root: {
                    fontSize: 13
                }
            }
        },
        MuiInputBase: {
            styleOverrides: {
                input: {
                    fontSize: 13
                }
            }
        },
        MuiAccordion: {
            styleOverrides: {
                root: {
                    marginTop: 0
                }
            }
        }
    }
})

const FacilityDetailPage = (props:any) => {
    const { isOpen, handleClose } = props;
    const [addGroundDetails, setAddGroundDetails] = useState(false);
    const data = useSelector((state:any) => state.dataCaptures.selectedFacility);
    const [t] = useTranslation();
    const dispatch = useDispatch();
    const isAdmin = useSelector((state:any) => state.common.isAdmin);

    const updateState = ((key:any, updatedData:any) => {
        const updatedFacility = {
            ...data,
            [key]: updatedData,
        };
        dispatch(setSelectedFacility(updatedFacility));
        const boolean:any = true;
        dispatch(setIsUpdatedFacility(boolean));
    });

    return (
            <React.Fragment>
                <ThemeProvider theme={theme}>
                <Popper className='popperStyle' open={isOpen} transition>
                        {({ TransitionProps }) => (
                <ClickAwayListener onClickAway={handleClose}>
                    <Fade {...TransitionProps} timeout={350}>
                                <Paper sx={{ p: 2, width: '1200px', mt: '20px', height: '650px', overflowY: 'auto' }}>
                                    <Box className='facilitiesFormStyles mb20'>
                                        <CustomTextField label={t('DC_6_FACILITY_NAME')} value={data?.facilityName} manageChange={(e:any) => {updateState('facilityName', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(data?.facilityName)} isDisabled={isAdmin} />
                                        <CustomTextField label={t('DC_6_SHORT_NAME')} value={data?.shortName} manageChange={(e:any) => {updateState('shortName', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(data?.shortName)} isDisabled={isAdmin} />
                                        <CustomTextField label={t('DC_6_ADDRESS')} value={data?.address} manageChange={(e:any) => {updateState('address', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(data?.address)} isDisabled={isAdmin} />
                                        <CustomTextField label={t('DC_6_OWNER')} value={data?.owner} manageChange={(e:any) => {updateState('owner', e)}} errorMessage={t('REQUIRED')} isError={isEmpty(data?.owner)} isDisabled={isAdmin} />
                                        <FacilityStatusSelect value={data?.facilityStatus} manageSelect={(e:any) => {updateState('facilityStatus', e)}} isError={isEmpty(data?.facilityStatus)} errorMessage={t('REQUIRED')} isReadOnly={isAdmin}/>
                                        <CapablitiesAutocomplete selectedValues={data?.capabilities ? data?.capabilities : []} manageSelect={(e:any) => {updateState('capabilities', e)}} isReadOnly={isAdmin} />
                                        <CustomTextField label={t('DC_6_N_OF_CHANGING_ROOMS')} type='number' value={data?.changingRooms} manageChange={(e:any) => {updateState('changingRooms', parseInt(e))}} errorMessage={t('REQUIRED')} isError={isEmpty(data?.changingRooms)} isDisabled={isAdmin} />
                                        <CustomTextField label={t('DC_6_DORMITORY_CAPACITY')} type='number' value={data?.dormitoryCapacity} manageChange={(e:any) => {updateState('dormitoryCapacity', parseInt(e))}} errorMessage={t('REQUIRED')} isError={isEmpty(data?.dormitoryCapacity)} isDisabled={isAdmin} />
                                    </Box>
                                    <Box className={'cursorNotAllowed'}>
                                        <JoyCssVarsProvider>
                                            <Textarea 
                                            sx={{ borderRadius: '6px', mt: 0, width: '100%', mb: '20px', 
                                                // TO DISPLAY THE TEXT IN BLACK COLOR EVEN IF THE TEXT AREA IS DISABLED
                                                '&.Mui-disabled': {
                                                    '--Textarea-disabledColor': 'black',
                                                    color: 'black',
                                                    cursor: 'not-allowed'
                                                }, }} 
                                                disabled={isAdmin}
                                            onChange={(e) => {updateState('dormitoryRemarks', e.target.value)}} placeholder='Dormintory Remarks...' 
                                            minRows={2} maxRows={2} value={data?.dormitoryRemarks}/>
                                        </JoyCssVarsProvider>
                                    </Box>
                                    <Box className={'mb20'}>
                                        <Box sx={{ display: 'flex', justifyContent: 'space-between', mb: 1 }}>
                                            <Typography className='standardsHeading uppercase'>Ground Details</Typography>
                                            {
                                                !isAdmin &&
                                                <Button className='smallButton' sx={{ float: 'right' }} disableElevation disabled={addGroundDetails} variant='contained' size='small' onClick={() => {setAddGroundDetails(true)}} startIcon={<FontAwesomeIcon icon={faPlus} />}>
                                                    {'Add ground details'}
                                                </Button>
                                            }
                                        </Box>
                                        <Box>
                                            <GroundDetailsTable 
                                            data={data?.facilityGrounds ? data?.facilityGrounds : []}
                                            addData={addGroundDetails} 
                                            handleClick={() => setAddGroundDetails(false)}
                                            updateList={(e:any) => {updateState('facilityGrounds', e)}}/>
                                        </Box>
                                    </Box>
                                </Paper>
                            </Fade>
                        </ClickAwayListener>
                        )}
                    </Popper>
                </ThemeProvider>
            </React.Fragment>
    )
}

export default FacilityDetailPage;